import React from 'react';
import { useImmersiveOverlay } from 'app/shared/halo/stores/immersiveOverlayStore';
import { CloseIcon, ListIcon } from 'app/shared/halo/components/ui/icons';
import * as styles from './immersiveOverlay.styles';

type ImmersiveFilterNavProps = {
  onClose: () => void;
};

export const ImmersiveFilterNav = ({ onClose }: ImmersiveFilterNavProps) => {
  const { index, total } = useImmersiveOverlay();

  const formattedTotal = total.toLocaleString('en-US');

  return (
    <div data-testid="immersive-nav" className={styles.immersiveHeader}>
      <button className={styles.immersiveHeaderButton} onClick={onClose} aria-label="Close property details">
        <CloseIcon />
      </button>
      {index > 0 && total > 0 && (
        <span className={styles.immersiveHeaderCounter}>
          Apartment {index} of {formattedTotal}
        </span>
      )}
      <button className={styles.immersiveHeaderButton} aria-label="View all listings">
        <ListIcon />
      </button>
    </div>
  );
};
